import { ALUMNI_PLATFORM } from '~/utils/alumni-platform';

export default {
	methods: {
		getUriAlumniMainPage() {
			return `/${ALUMNI_PLATFORM.PAGES.MAIN.slug}`;
		},
	},
};
